import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import {
  NOTIFICATION_ERROR_TIME,
  NOTIFICATION_INFO_TIME,
  NOTIFICATION_SUCCESS_TIME,
  NOTIFICATION_WARNING_TIME,
} from '@properties/application.properties';
import { NotificationTypeEnum } from '../enums/notification-type.enum';
import { NotificationInterface } from '../models/notification.interface';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  readonly successTime: number = NOTIFICATION_SUCCESS_TIME;
  readonly errorTime: number = NOTIFICATION_ERROR_TIME;
  readonly warningTime: number = NOTIFICATION_WARNING_TIME;
  readonly infoTime: number = NOTIFICATION_INFO_TIME;

  private subject = new Subject<NotificationInterface>();
  pool = this.subject.asObservable();

  /**
   * add success alert on the page
   * @param title - title of the message
   * @param message - alert message to display in alert content
   * @param timeout - timeout (milliseconds), time when user can see message
   */
  success = (message: string, title?: string, link?: string, notificationId?: string, timeout: number = this.successTime): void => {
    this.subject.next({
      title,
      message,
      link,
      notificationId,
      time: timeout,
      type: NotificationTypeEnum.SUCCESS,
    });
  };

  /**
   * add error alert on the page
   * @param title - title of the message
   * @param message - alert message to display in alert content
   * @param timeout - timeout (milliseconds), time when user can see message
   */
  error = (message: string, title?: string, timeout: number = this.errorTime): void => {
    this.subject.next({
      title,
      message,
      time: timeout,
      type: NotificationTypeEnum.ERROR,
    });
  };

  /**
   * add warning alert on the page
   * @param title - title of the message
   * @param message - alert message to display in alert content
   * @param timeout - timeout (milliseconds), time when user can see message
   */
  warning = (message: string, title?: string, timeout: number = this.warningTime): void => {
    this.subject.next({
      title,
      message,
      time: timeout,
      type: NotificationTypeEnum.WARNING,
    });
  };

  /**
   * add info alert on the page
   * @param title - title of the message
   * @param message - alert message to display in alert content
   * @param timeout - timeout (milliseconds), time when user can see message
   */
  info = (message: string, title?: string, timeout: number = this.infoTime): void => {
    this.subject.next({
      title,
      message,
      time: timeout,
      type: NotificationTypeEnum.INFO,
    });
  };
}
